const services = [
  {
    image:
      'https://images.unsplash.com/39/lIZrwvbeRuuzqOoWJUEn_Photoaday_CSD%20%281%20of%201%29-5.jpg?crop=entropy&cs=tinysrgb&fit=max&ixid=M3w3Mzk3NjZ8MHwxfHNlYXJjaHwyfHxCdXNpbmVzcyUyMGNvbnN1bHRpbmd8ZW58MHx8fHwxNzc1NDI2MDA0fDA&ixlib=rb-4.1.0&w=1080&auto=format',
    alt: 'C-Suite Leadership',
    title: 'C-Suite Leadership & Turnaround Strategy',
    description:
      'Expert guidance on executive-level transformations and business turnarounds. We work with C-suite leaders to develop and execute strategic initiatives that drive organizational change, improve decision-making, and position your company for sustainable growth and success.',
  },
  {
    image:
      'https://images.unsplash.com/photo-1573164574511-73c773193279?crop=entropy&cs=tinysrgb&fit=max&ixid=M3w3Mzk3NjZ8MHwxfHNlYXJjaHwzfHxCdXNpbmVzcyUyMGNvbnN1bHRpbmd8ZW58MHx8fHwxNzc1NDI2MDA0fDA&ixlib=rb-4.1.0&w=1080&auto=format',
    alt: 'Profitability Enhancement',
    title: 'Profitability Enhancement & Operations Optimization',
    description:
      'Comprehensive analysis and optimization of your business operations, supply chain, and cost structures. We identify inefficiencies, streamline processes, and implement strategic improvements to significantly enhance profitability and operational excellence.',
  },
  {
    image:
      'https://images.unsplash.com/photo-1460925895917-afdab827c52f?crop=entropy&cs=tinysrgb&fit=max&ixid=M3w3Mzk3NjZ8MHwxfHNlYXJjaHw4fHxCdXNpbmVzcyUyMGNvbnN1bHRpbmd8ZW58MHx8fHwxNzc1NDI2MDA0fDA&ixlib=rb-4.1.0&w=1080&auto=format',
    alt: 'Strategic Sales & Exit Planning',
    title: 'Strategic Sales & Exit Planning',
    description:
      'Specialized consulting to prepare your business for strategic sale to private equity or venture capital firms. We enhance company valuation, optimize financial performance, and guide you through the entire exit process to maximize returns and ensure a successful transaction.',
  },
];

export default function Services() {
  return (
    <section id="products" className="py-20 px-6 bg-texas-cream">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <span className="text-texas-red text-xs font-bold tracking-widest uppercase mb-3 block">What We Do</span>
          <h2 className="text-3xl md:text-4xl font-bold text-texas-navy">
            Our Services
          </h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service) => (
            <div
              key={service.title}
              className="bg-white rounded-lg overflow-hidden flex flex-col border border-gray-100"
            >
              <div className="w-full h-[200px] overflow-hidden relative">
                <img
                  src={service.image}
                  alt={service.alt}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-texas-navy/30 to-transparent" />
              </div>
              <div className="p-6 flex flex-col flex-1 border-t-2 border-texas-red">
                <h3 className="text-base font-bold text-texas-navy text-center mb-3 leading-snug">
                  {service.title}
                </h3>
                <p className="text-gray-500 text-sm leading-relaxed">{service.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
